module.exports = __webpack_public_path__ + "img/icon-setting.28d6644e.svg";